module.exports = __webpack_public_path__ + "media/images/career_camp/2023/hero/title-3a81b10aebb64e6bf91138bdd9b199b0.svg";